// extracted by mini-css-extract-plugin
export default {"item":"itemMenu_item__SmZ6x","active":"itemMenu_active__1T3zm"};